import { di } from 'react-magnetic-di';

import type { IconTileProps } from '@atlaskit/icon/types';

import { getAppearanceForIndex } from '../../../utils';

export const useAppearanceForIndex = (
	index: number,
	buildType: string,
): IconTileProps['appearance'] => {
	di(getAppearanceForIndex);
	return getAppearanceForIndex(index, buildType);
};
